import { useEffect, useState, FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Fade } from "react-awesome-reveal";
import TestOwner from "../../components/test/registration/testOwner";
import BasicInfo from "../../components/test/registration/basicInfo";
import Navbar from "../../components/test/registration/navbar";
import AnalyseType from "../../components/test/registration/analyseType";
import { startAnalysis, submitTest } from "../../services/test";
import { payForPro } from "../../services/proAnalyse";
import useStore from "../../features/store";

const TestRegistration: FC = () => {
  const navigate = useNavigate();
  const {
    plans,
    fetchPlans,
    errorFreeAnalysis,
    fetchFreeAnalysis,
    profile,
  }: any = useStore();
  const isProfileComplete =
    profile?.user?.first_name &&
    profile?.user?.last_name &&
    profile?.birth_day &&
    profile?.gender !== "UNKNOWN"
      ? true
      : false;

  const [step, setStep] = useState<number>(1);
  const [testOwner, setTestOwner] = useState<number | null>(null);
  const [tempProfile, setTempProfile] = useState<any>(null);
  const [testData, setTestData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [discountCode, setDiscountCode] = useState<any>("");
  const [selectedPlan, setSelectedPlan] = useState<any>(null);

  useEffect(() => {
    if (!plans && profile) fetchPlans();
  }, [profile, plans, fetchPlans]);

  useEffect(() => {
    if (profile) fetchFreeAnalysis();
  }, [profile, fetchFreeAnalysis]);

  const handleSubmission = async (plan: any) => {
    setSelectedPlan(plan.id);
    try {
      setLoading(true);

      const response = await submitTest(testData);
      setLoading(false);

      if (response.status !== 201) {
        toast.error("مشکلی برای ثبت آزمایش پیش آمد");
      }

      if (plan.id !== 1) {
        const paymentData = {
          plan_id: plan.id,
          discount_code: discountCode,
          id: response.data.id,
        };
        const paymentResponse = await payForPro(paymentData);

        if (paymentResponse?.response?.status === 400) {
          if (
            paymentResponse?.response?.data?.error === "Invalid discount code."
          ) {
            toast.error("کد تخفیف ثبت شده معتبر نیست");
          } else {
            toast.error(
              "درگاه پرداخت پاسخگو نیست لطفا دقایقی بعد دوباره تلاش کنید"
            );
          }
        }

        if (paymentResponse?.data?.url) {
          // navigate(`/checkout/${paymentResponse?.data?.url?.split("/").pop()}`);
          window.location.href = paymentResponse.data.url;
        } else {
          if (
            !paymentResponse?.data?.url &&
            paymentResponse?.data?.amount === 0
          ) {
            navigate(`/additional-information/${response.data.id}`);
          }
        }
      } else {
        const analysisResponse = await startAnalysis(response.data.id);
        if (analysisResponse.status === 200) {
          navigate(`/test-analysis/${response.data.id}`);
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error("مشکلی برای ثبت آزمایش پیش آمد");
    }
  };

  if (profile && !isProfileComplete) {
    return (
      <Fade triggerOnce>
        <div className="mt-32 flex flex-col items-center justify-cneter">
          <h1 className="font-rokh font-[900] text-xl text-center">
            برای تحلیل آزمایش، لازمه اول پروفایل رو کامل کنی
          </h1>
          <Link
            to="/profile/update?redirect=test-registration"
            className="mt-5 bg-pr_primary hover:bg-pr_blue_dark text-white px-10 py-3 rounded"
          >
            تکمیل پروفایل
          </Link>
        </div>
      </Fade>
    );
  } else if (loading) {
    return (
      <div className="h-[80vh] w-full flex flex-col items-center justify-center">
        <span className="loading loading-dots loading-lg"></span>
        {selectedPlan === 2 ? (
          <div className="flex flex-col items-center justify-center">
            <h1 className="font-rokh font-[900] text-xl mt-3">
              در حال انتقال به درگاه پرداخت
            </h1>
            <p className="font-rokh font-[500] text-sm">
              اگه فیلتر‌شکن رو خاموش کنی، سریع‌تر می‌تونی بری.
            </p>
          </div>
        ) : (
          <h1 className="font-rokh font-[900] text-xl mt-3">
            در حال شروع تحلیل آزمایش
          </h1>
        )}
      </div>
    );
  } else {
    return (
      <div className="relative flex-1 flex flex-col items-center mt-5">
        <Navbar step={step} setStep={setStep} />

        {step === 1 && (
          <TestOwner
            testOwner={testOwner}
            setTempProfile={setTempProfile}
            setTestOwner={setTestOwner}
            setStep={setStep}
          />
        )}
        {step === 2 && (
          <BasicInfo
            tempProfile={tempProfile}
            setStep={setStep}
            setTestData={setTestData}
            isForAnother={testOwner !== 1}
          />
        )}
        {step === 3 && (
          <AnalyseType
            loading={loading}
            plans={plans}
            errorFreeAnalysis={errorFreeAnalysis}
            discountCode={discountCode}
            setDiscountCode={setDiscountCode}
            submitTestHandler={handleSubmission}
            selectedPlan={selectedPlan}
          />
        )}
      </div>
    );
  }
};

export default TestRegistration;
